module.exports = {"name":"Hlavička detailu osoby","icon":"<i class='material-icons'>accessibility</i>","widget":[{"type":"detail-title","initData":{},"api":{"url":"persons/detail","id":"personId"},"paths":{"image":{"src":"photoInfo.photo","type":"person"},"title":["baseData.name.v","baseData.surName.v"],"subtitle":["baseData.gender","baseData.nationality"]}}]}


//////////////////
// WEBPACK FOOTER
// ./src/blocks/person-detail-title/person-detail-title.json
// module id = 378
// module chunks = 0